import keyMirror from 'keymirror'

const ModalConstants = keyMirror({
  SHOW_MODAL: null,
  CLOSE_MODAL: null,
})

export default ModalConstants
